import styled from 'styled-components'
import {Container} from '@miro-site/core'

const HeaderContainer = styled(Container).attrs(({theme}) => ({
  as: 'div',
  $px: theme.header.container.horizontalPadding,
  $styles: {
    maxWidth: theme.header.container.maxWidth,
  },
}))``

HeaderContainer.displayName = 'HeaderContainer'

export default HeaderContainer
